module.exports = __webpack_public_path__ + "img/11_41.662adb77.png";